import { EmptyState } from "../../components/StatusView";
import { useCreateGlobalNetwork } from "./globalNetworkHooks";

/** Warning-toned prompt shown when the shared global network hasn't been created yet. */
export function GlobalNetworkEmptyState({ onCreated }: { onCreated: () => void }) {
  const { submit, submitting, error } = useCreateGlobalNetwork();

  async function handleCreate() {
    const response = await submit();
    if (response) {
      onCreated();
    }
  }

  return (
    <EmptyState
      tone="warn"
      title="Global network not created"
      body="No shared public network exists yet. Create it to start managing shared-network instances, usage, cost, and activity — separate from any user's dedicated server."
    >
      <button type="button" className="btn btn--warn" disabled={submitting} onClick={handleCreate}>
        {submitting ? "Creating…" : "Create Global Network"}
      </button>
      {error ? (
        <p className="form-error" role="alert">
          {error}
        </p>
      ) : null}
    </EmptyState>
  );
}
